import { omit } from 'lodash-es';
import type { MutableRefObject } from 'react';
import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils.ts';

type CommonProps = {
    text?: string;
} & React.PropsWithChildren;

type ButtonProps = { as: 'button' } & Omit<React.ComponentPropsWithoutRef<'button'>, 'children'>;
type AnchorProps = { as?: 'a' } & Omit<React.ComponentPropsWithoutRef<'a'>, 'children'>;

type Props = CommonProps & (ButtonProps | AnchorProps);

export const LinkText = forwardRef<HTMLElement, Props>((props, ref) => {
    const commonProps = {
        className: cn(
            'cursor-pointer select-none text-sm font-medium text-blue-500 hover:text-blue-600 hover:underline',
            props.className,
        ),
        children: props.text || props.children,
    };

    if (props.as === 'button') {
        return (
            <button
                ref={ref as MutableRefObject<HTMLButtonElement>}
                type="button"
                {...omit(props, ['as', 'className', 'text'])}
                {...commonProps}
            />
        );
    }

    return (
        <a
            ref={ref as MutableRefObject<HTMLAnchorElement>}
            {...omit(props, ['as', 'className', 'text'])}
            {...commonProps}
        />
    );
});

LinkText.displayName = 'LinkText';
